<template>
  <b-row v-if="isLoading" style="justify-content: center">
    <b-spinner label="Loading..." variant="dark" />
  </b-row>

  <div v-else>
    <b-row v-if="credentials && credentials.length" style="justify-content: flex-start">
      <b-col
        v-for="credential in credentials"
        :key="credential.id"
        class="p-3"
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="4"
      >
        <BaseCardBadge
          :id="`credential_lu_${credential.learning_unit_id}`"
          :key="credential.learning_unit_id"
          :ref="`credential_lu_${credential.learning_unit_id}`"
          :credential="credential"
        ></BaseCardBadge>
      </b-col>
    </b-row>

    <div v-else class="w-100">
      <div class="d-flex justify-content-center mb-2 mt-5">
        <div class="font-weight-bold h5">No badge collection to display</div>
      </div>
      <div class="d-flex justify-content-center text-dark mb-4">
        Find micro-credential that match your skill set.
      </div>
      <div class="d-flex justify-content-center">
        <b-button variant="first" @click="goToLUExplorePage"> Explore </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { userInfoMixin } from '@/mixins/userInfoMixin';
import Credential from '@/models/Credential';
import BaseCardBadge from '@/components/base-components/BaseCardBadge.vue';
export default {
  components: {
    BaseCardBadge
  },
  mixins: [userInfoMixin],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    learningUnitId() {
      return this.$route.query.learningUnitId ? this.$route.query.learningUnitId : null;
    },

    credentials() {
      return Credential.query()
        .where('user_id', this.userId)
        .with('learning_unit')
        .orderBy('created_at', 'desc')
        .get();
    }
  },

  mounted() {
    this.fetchBadges();
  },

  methods: {
    scrollToCardBadge() {
      this.$nextTick(() => {
        setTimeout(() => {
          const ref = this.$refs[`credential_lu_${this.learningUnitId}`];
          if (ref && ref.length) {
            ref[0].$el.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      });
    },

    async fetchBadges() {
      try {
        this.isLoading = true;
        await Credential.api().fetchByLearner();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;

        if (this.learningUnitId) {
          await this.scrollToCardBadge();
        }
      }
    },

    goToLUExplorePage() {
      this.$router.push({ name: 'learning-unit' });
    }
  }
};
</script>
